import type { ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

export type ChartCardProps = {
  title: string;
  description?: string;
  action?: ReactNode;
  isLoading?: boolean;
  isEmpty?: boolean;
  emptyText?: string;
  height?: number;
  className?: string;
  contentClassName?: string;
  children: ReactNode;
  testId?: string;
};

export function ChartCard({
  title, description, action, isLoading, isEmpty, emptyText = "No data",
  height = 200, className, contentClassName, children, testId,
}: ChartCardProps) {
  return (
    <Card className={cn("flex-1", className)} data-testid={testId}>
      <CardHeader className="pb-2">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <CardTitle className="text-sm font-medium">{title}</CardTitle>
            {description ? (
              <p className="mt-0.5 text-xs text-muted-foreground">{description}</p>
            ) : null}
          </div>
          {action ? <div className="shrink-0">{action}</div> : null}
        </div>
      </CardHeader>
      <CardContent className={cn("pt-2", contentClassName)}>
        {isLoading ? (
          <Skeleton style={{ height }} className="w-full" />
        ) : isEmpty ? (
          <div
            style={{ height }}
            className="flex items-center justify-center text-muted-foreground text-sm"
          >
            {emptyText}
          </div>
        ) : (
          <div style={{ height }} className="w-full">
            {children}
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export default ChartCard;
